import Vue from 'vue'
import Vuex from 'vuex'
import { sysConfigs_stadiumConfig } from '@/apis/user'

Vue.use(Vuex)


/* 獲取系統配置 */
async function getSystemConfig() {
    try {
        const res = await sysConfigs_stadiumConfig();
        if (res.code == 0) {
            const config = res.data;
            return config;
        }
    } catch (error) {

    }



    // const systemConfigJson = localStorage.getItem('systemConfig');
    // if (systemConfigJson) {
    //     const config = JSON.parse(systemConfigJson);
    //     return config;
    // } else {
    //     const res = await sysConfigs_stadiumConfig();
    //     if (res.code == 0) {
    //         const config = res.data;
    //         localStorage.setItem('systemConfig', JSON.stringify(config));
    //         return config;
    //     }
    // }
}


export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        userId: localStorage.getItem('userId') || '',
        username: localStorage.getItem('username') || '',
        //當前位置的就近場館
        currentGym: localStorage.getItem('currentGym') || {},
        systemConfig: await getSystemConfig() || []
    },
    mutations: {
        // refresh token
        UPDATE_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        // set tokens
        SET_TOKENS(state, { token, refreshToken }) {
            state.token = token
            state.refreshToken = refreshToken
            localStorage.setItem('token', token)
            localStorage.setItem('refreshToken', refreshToken)
        },
        // clear token
        CLEAR_TOKENS(state) {
            state.token = ''
            state.refreshToken = ''
            state.username = '';
            state.userId = '';
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('userId')
            localStorage.removeItem('username')
        },
        SET_USERID(state, userId) {
            state.userId = userId;
            localStorage.setItem('userId', userId)
        },
        SET_USERNAME(state, username) {
            if (username) {
                state.username = username;
                localStorage.setItem('username', username)
            }
        },
        SET_CURRENT_GYM(state, currentGym) {
            if (currentGym) {
                state.currentGym = currentGym;
                localStorage.setItem('currentGym', currentGym)
            }
        }
    },
    actions: {
        logout({ commit }) {
            commit('CLEAR_TOKENS')
            // 跳轉至登錄頁
            location.href = '/login';
        }
    }
})